import React, { useState } from 'react';

const InputField = ({ title, type, className, name, value, onChange }) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <div className={`relative my-8 ${className}`} dir="rtl">
            <input
                type={type}
                name={name}
                value={value}  // Controlled input
                onChange={onChange}  // Uses parent's state handler
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(value !== '')}
                className="w-full px-4 pt-3 pb-2 text-md bg-transparent border border-gray-400 rounded-md shadow appearance-none focus:outline-light-primary focus:border-blue-500 transition-all peer text-right"
            />
            <label
                className={`absolute right-4 text-gray-500 text-md transition-all bg-light-bg px-1 ${
                    isFocused || value ? '-top-2 text-xs text-blue-500' : 'top-1/2 -translate-y-1/2'
                }`}
            >
                {title}
            </label>
        </div>
    );
};

export default InputField;
